// Which build this is (security split, 2026-10-21):
//   'public'   — client + investor portals only (AppPublic.js)
//   'admin'    — staff only, served privately (AppAdmin.js)
//   'combined' — everything in one app (App.js), the setup before the split
export const PORTAL = process.env.REACT_APP_PORTAL || 'combined';
export const ADMIN_PORTAL_ROLES = PORTAL === 'admin'
  ? ['admin', 'analyst', 'compliance', 'investor_relations', 'operations']
  : ['admin', 'analyst', 'operations'];
// Staff roles that only see their own screens in the admin portal.
export const LIMITED_STAFF_NAV = {
  compliance: ['/admin/kyc-compliance', '/admin/kyc-review'],
  investor_relations: ['/admin/portfolio-metrics'],
};
